import type { ColumnDef } from '@tanstack/react-table';
import { CellAction } from './cell-action';
import { Badge } from '@/components/ui/badge';

export const columns: ColumnDef<any>[] = [
  {
    accessorKey: 'name',
    header: 'Category',
    cell: ({ row }) => (
      <div className="font-medium text-foreground">
        {row.original.name}
      </div>
    )
  },
  {
    accessorKey: 'tags',
    header: 'Data',
    cell: ({ row }) => {
      const tags = row.original.tags || [];
      const displayTags = tags.slice(0, 4); // Show only first 4 items
      const remainingCount = tags.length - 4;
      
      return (
        <div className='flex flex-wrap gap-1'>
          {displayTags.map((tag: string, i: number) => (
            <Badge
              key={i}
              variant="secondary"
              className='flex-shrink-0 rounded-full px-3 py-1 text-sm font-normal'
            >
              {tag}
            </Badge>
          ))}
          {remainingCount > 0 && (
            <Badge
              variant="outline"
              className='flex-shrink-0 rounded-full px-3 py-1 text-sm font-normal text-muted-foreground'
            >
              +{remainingCount} more
            </Badge>
          )}
          {tags.length === 0 && (
            <span className="text-sm text-muted-foreground">No data</span>
          )}
        </div>
      );
    }
  },
  {
    id: 'actions',
    header: 'Actions',
    cell: ({ row }) => <CellAction data={row.original} />
  }
];